/* Zeus CTA A/B tests — persistent visitor assignment + hero/checkout variants. */
(function () {
  "use strict";

  var STORAGE_KEY = "zeus_cta_ab_v1";
  var VISITOR_KEY = "zeus_cta_ab_visitor";

  var CHECKOUT_COLORS = {
    gold: {
      bg: "var(--zeus-gold)",
      fg: "var(--zeus-navy)",
      border: "var(--zeus-navy)",
      shadow: "var(--zeus-burnt)",
    },
    burnt: {
      bg: "var(--zeus-burnt)",
      fg: "var(--zeus-ink)",
      border: "var(--zeus-navy)",
      shadow: "var(--zeus-navy)",
    },
    sky: {
      bg: "var(--zeus-sky)",
      fg: "var(--zeus-navy)",
      border: "var(--zeus-navy)",
      shadow: "var(--zeus-burnt)",
    },
    navy: {
      bg: "var(--zeus-navy)",
      fg: "var(--zeus-white)",
      border: "var(--zeus-navy)",
      shadow: "var(--zeus-burnt)",
    },
  };

  function readConfig() {
    var node = document.getElementById("zeus-cta-ab-config");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function getVisitorId() {
    try {
      var existing = localStorage.getItem(VISITOR_KEY);
      if (existing) return existing;
      var id = "zab_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem(VISITOR_KEY, id);
      return id;
    } catch (e) {
      return "zab_anon";
    }
  }

  function readAssignments() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function writeAssignments(assignments) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(assignments));
    } catch (e) {}
  }

  function hashToBucket(seed) {
    var hash = 0;
    for (var i = 0; i < seed.length; i++) {
      hash = (hash << 5) - hash + seed.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash) % 100;
  }

  function urlOverride(param) {
    try {
      return new URLSearchParams(window.location.search).get(param);
    } catch (e) {
      return null;
    }
  }

  function resolveVariant(experimentId, experiment) {
    var forced = urlOverride("zeus_ab_" + experimentId.replace("_cta", ""));
    if (forced === "a" || forced === "b") return forced;

    var assignments = readAssignments();
    if (assignments[experimentId]) return assignments[experimentId];

    var splitB = parseInt(experiment.splitB, 10);
    if (isNaN(splitB)) splitB = 50;
    splitB = Math.max(0, Math.min(100, splitB));

    var bucket = hashToBucket(getVisitorId() + ":" + experimentId);
    var variant = bucket < splitB ? "b" : "a";
    assignments[experimentId] = variant;
    writeAssignments(assignments);
    return variant;
  }

  function pageMatches(scope) {
    var body = document.body;
    if (!body) return false;
    if (scope === "index") return body.classList.contains("template-index");
    if (scope === "cart") {
      return (
        body.classList.contains("template-cart") ||
        !!document.querySelector("cart-drawer[open], .cart-drawer[open], #cart-drawer[open]")
      );
    }
    return true;
  }

  function track(experimentId, variant, action, el) {
    var detail = {
      experiment: experimentId,
      variant: variant,
      action: action,
    };
    document.dispatchEvent(new CustomEvent("zeus:cta-ab", { detail: detail }));
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "zeus_cta_ab",
        zeus_ab_experiment: experimentId,
        zeus_ab_variant: variant,
        zeus_ab_action: action,
      });
    }
    if (el && action === "click") {
      el.setAttribute("data-zeus-ab-clicked", variant);
    }
  }

  function setLabel(el, label) {
    var icon = el.querySelector("svg");
    if (icon) {
      var textNode = Array.prototype.find.call(el.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      if (textNode) {
        textNode.textContent = label;
      } else {
        el.insertBefore(document.createTextNode(label), icon);
      }
      return;
    }
    el.textContent = label;
  }

  function applyCheckoutColor(el, token) {
    var palette = CHECKOUT_COLORS[token] || CHECKOUT_COLORS.gold;
    el.style.background = palette.bg;
    el.style.color = palette.fg;
    el.style.borderColor = palette.border;
    el.style.boxShadow = "6px 6px 0 " + palette.shadow;
    el.setAttribute("data-zeus-ab-checkout-color", token);
  }

  function applyHeroExperiment(config, experiment) {
    if (!experiment.enabled || !pageMatches(experiment.scope)) return;

    var variantKey = resolveVariant("hero_cta", experiment);
    var variant = experiment.variants[variantKey];
    if (!variant) return;

    document.querySelectorAll('[data-zeus-ab-target="hero-cta"]').forEach(function (el) {
      if (el.getAttribute("data-zeus-ab-applied") === variantKey) return;
      var label = variant.label || el.getAttribute("data-zeus-ab-control") || el.textContent.trim();
      setLabel(el, label);
      el.setAttribute("data-zeus-ab-variant", variantKey);
      el.setAttribute("data-zeus-ab-applied", variantKey);
      track("hero_cta", variantKey, "exposure", el);
      if (!el.getAttribute("data-zeus-ab-bound")) {
        el.setAttribute("data-zeus-ab-bound", "1");
        el.addEventListener("click", function () {
          track("hero_cta", variantKey, "click", el);
        });
      }
    });
  }

  function applyCheckoutExperiment(config, experiment) {
    if (!experiment.enabled || !pageMatches(experiment.scope)) return;

    var variantKey = resolveVariant("checkout_cta", experiment);
    var variant = experiment.variants[variantKey];
    if (!variant) return;

    document.querySelectorAll('[data-zeus-ab-target="checkout-cta"]').forEach(function (el) {
      if (el.getAttribute("data-zeus-ab-applied") === variantKey) return;
      var label = variant.label || el.getAttribute("data-zeus-ab-control") || el.textContent.trim();
      setLabel(el, label);
      applyCheckoutColor(el, variant.color || el.getAttribute("data-zeus-ab-checkout-control") || "gold");
      el.setAttribute("data-zeus-ab-variant", variantKey);
      el.setAttribute("data-zeus-ab-applied", variantKey);
      track("checkout_cta", variantKey, "exposure", el);
      if (!el.getAttribute("data-zeus-ab-bound")) {
        el.setAttribute("data-zeus-ab-bound", "1");
        el.addEventListener("click", function () {
          track("checkout_cta", variantKey, "click", el);
        });
      }
    });
  }

  var applyRaf = false;

  function scheduleApply() {
    if (applyRaf) return;
    applyRaf = true;
    requestAnimationFrame(function () {
      applyRaf = false;
      applyAll();
    });
  }

  function applyAll() {
    var config = readConfig();
    if (!config || !config.enabled || !config.experiments) return;

    if (urlOverride("zeus_ab_reset") === "1") {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }

    applyHeroExperiment(config, config.experiments.hero_cta || {});
    applyCheckoutExperiment(config, config.experiments.checkout_cta || {});
  }

  function init() {
    applyAll();

    var observer = new MutationObserver(function () {
      scheduleApply();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["open"],
    });
  }

  window.ZeusCtaAbTests = {
    apply: applyAll,
    getAssignments: readAssignments,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
